<template>
  <div id="order-page">
    <v-container>
      <div class="_fs-36">
        ประวัติการทำรายการ
      </div>

      <template v-if="orders.length > 0">
        <order-card-list
          class="mt-4"
          :orders="mapOrders"
          @deleted="onDeleted">
        </order-card-list>

        <v-pagination
          class="mt-4"
          :value="page"
          :length="ordersPageData.totalPages"
          @input="onChangePage">
        </v-pagination>
      </template>

      <div
        v-else
        class="py-10 text-center grey--text _fs-20">
        Basic ID นี้ยังไม่มีการทำรายการ
      </div>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import { mapWaitingActions } from 'vue-wait'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'OrderPage',
  components: {
    OrderCardList: () => import('@/components/OrderCardList')
  },
  data () {
    return {
      page: +this.$route.query.page || 1
    }
  },
  computed: {
    ...mapState('Order', ['orders', 'ordersPageData']),
    mapOrders () {
      return this.orders.map(
        ({ orderItems, ...filterOrder }) => ({
          ...filterOrder,
          orderItems: orderItems.filter(({ productType }) => productType !== 'fee')
        })
      )
    }
  },
  async beforeRouteEnter (to, from, next) {
    store.dispatch('wait/start', 'app loading', { root: true })
    await store.dispatch('Order/fetchOrders', { page: to.query.page || 1 })
    store.dispatch('wait/end', 'app loading', { root: true })
    next()
  },
  methods: {
    ...mapActions({
      fetchOrders: 'Order/fetchOrders'
    }),
    ...mapWaitingActions('Order', {
      fetchOrders: 'app loading'
    }),
    onChangePage (page) {
      this.page = page
      this.fetchOrders({ page: this.page })
      this.$router.replace({ name: 'OrderList', query: { page } })
    },
    onDeleted () {
      this.onChangePage(1)
    }
  }
}
</script>
